import script from "./BlogIndexView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogIndexView.vue?vue&type=script&setup=true&lang=ts"

import "./BlogIndexView.vue?vue&type=style&index=0&id=423d2cc6&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423d2cc6"]])

export default __exports__